import Axios from 'axios'
import APIUrls from '../APIUrls';
import Constants from '../../Constants';
import Cookies from 'universal-cookie';
import axiosRetry from 'axios-retry';


    const cookies = new Cookies();

    Axios.defaults.withCredentials = true
    const AuthAxiosInst = Axios.create({
        baseURL : process.env.REACT_APP_BACKEND_SERVER
    });

    export const loginFunc = (payload) => {
        return AuthAxiosInst.post(APIUrls.LoginUrl, payload).then((res) => {
            if (res.status === 200) {
                switch (res.data.msg.toLowerCase()) {
                      case Constants.BAD_CREDENTIALS.toLowerCase():
                            res.data.msg = Constants.INVALID_CREDENTIALS
                            break
                      case Constants.INTERNAL_SERVER_ERROR.toLowerCase():
                            res.data.msg = Constants.SOMETHING_WENT_WRONG
                            break;
                            default:
                }
            }
            return res;
        })
    }

    export const forgotPassword =  (payload) => {
        return AuthAxiosInst.post(APIUrls.FORGOT_PASSWORD,payload)
    }

     export const logoutFunc=()=>{
        return AuthAxiosInst.get(APIUrls.LogoutUrl);

    }

    export const sessionInfoFunc=()=>{
        return AuthAxiosInst.get(APIUrls.SessionInfoUrl);
    }

    export const forgotPasswordVerify =  (payload) => {
        return AuthAxiosInst.post(APIUrls.VERIFY_PASSWORD,payload)
    }

    export const getUserInfo =  (payload) => {
        return AuthAxiosInst.post(APIUrls.USER_INFO,payload)
    }

    export const provisioningApiGetRequest = (url, email) => {
        return Axios({
            url : `${process.env.REACT_APP_BACKEND_SERVER}${url}`,
            method : "GET",
            headers: {
                'userEmail': email
            }
        });
    }

    export const provisioningApiPostRequest = (url, email, form) => {
        var formData = new URLSearchParams(form).toString();
        return Axios({
            url : `${process.env.REACT_APP_BACKEND_SERVER}${url}`,
            method : "POST",
            data: formData,
            headers: {
                'userEmail': email
            }
        });
    }


    export const getAxiosResponse = (url, config) => {
        return AuthAxiosInst.get(url, config)
    }

    export const getCsrfToken = () => {
        return AuthAxiosInst.get(APIUrls.CSRF_TOKEN_URL)
        .then((res) => {
            if (res.status === 200) {
                var csrfToken = res.data.csrfToken;
                //for testing purpose
                localStorage.setItem("csrfToken",csrfToken)
            }
        }).catch((err) => {
            console.error("Error while executing getCsrfToken. Reason: ", err.message);
        });
    }

    export const postAxiosResponse = (url,payload, config) => {
        return AuthAxiosInst.post(url, payload, config ? config : {})
    }

    export const postAxiosFormDataResponse = (url,payload) => {
        return AuthAxiosInst.post("postForm"+url, payload)
    }

    export const putAxiosResponse = (url,payload) => {
        return AuthAxiosInst.put(url, payload);
    }

    export const putOrPostAxiosResponse = (url,payload, isPost) => {
        if (isPost) {
            return postAxiosResponse(url, payload);
        }
        return putAxiosResponse(url, payload);
    }

    export const getAxiosResponseAndSetState = (url, stateSetter) => {
        AuthAxiosInst.get(url)
        .then((res) => {
            if (res.data.code === 200) {
                stateSetter(res.data.data);
            }
        }).catch((err) => {
            console.error("Error while executing getAxiosResponseAndSetState. Reason: ", err.message);
        })
    }

    export const getAxiosResponseAndSetStateForArray = (url, stateSetterForArray) => {
        AuthAxiosInst.get(url)
        .then((res) => {
            if (res.data.code === 200) {
                const options = res.data.data.map(({ id, name }) => ({
                    label: name,
                    value: id,
                }));
                stateSetterForArray(options);
            }
        }).catch((err) => {
            console.error("Error while executing getAxiosResponseAndSetStateForArray. Reason: ", err.message);
        })
    }

    export const getAxiosResponseAndSetStateForArrayProjectFilters = (url, stateSetterForArray) => {
        AuthAxiosInst.get(url)
        .then((res) => {
            if (res.data.code === 200) {
                const options = [{label : Constants.SELECT, value : Constants.SINGLE_WHITESPACE}];
                res.data.data.map(({ id, name }) => (
                    options.push({
                        label: name,
                        value: id
                    })
                ));
                stateSetterForArray(options);
            }
        }).catch((err) => {
            console.error("Error while executing getAxiosResponseAndSetStateForArray. Reason: ", err.message);
        })
    }
    export const deleteAxiosResponse = (url) => { 
        return AuthAxiosInst.delete(url)
    }

    export const downloadLink = (url) => {
        return `${process.env.REACT_APP_BACKEND_SERVER}/download${url}`;
    }


    export const downloadFile = (url, filename) => {
        return new Promise((resolve, reject) => {
    try {
      const a = document.createElement("a");    
      a.href = downloadLink(url);      
      if(filename) a.download = filename;        
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); // Clean up
      resolve(); // Resolve when download is initiated
    } catch (error) {
      reject(error); // Reject if there's an error
    }
  });
};

    export const getNewCsrfToken = async() => {
        return await AuthAxiosInst.get(APIUrls.CSRF_TOKEN_URL)
        .then((res) => {
            if (res.status === 200) {
                return res.data.csrfToken;
            }
        }).catch((err) => {
            console.error("Error while executing getCsrfToken. Reason: ", err.message);
        });
    }

        axiosRetry(AuthAxiosInst, {
            retryDelay: (retryCount) => {
                return retryCount * 1000;
            },
            onRetry : async(retryCount, error, requestConfig) => {
                if(error.response?.data?.includes('invalid csrf token')){
                    const csrfToken = await getNewCsrfToken();
                    localStorage.setItem("csrfToken",csrfToken);
                    requestConfig.headers['CSRF-Token'] = csrfToken;
                }
            },
            retryCondition: (error) => {
                return (error.code === 'ERR_NETWORK' && error.config.method === 'get') || error.response?.data?.includes('invalid csrf token');
            }
        });

    AuthAxiosInst.interceptors.request.use(
        (req) => {
           // Add configurations here
           if (req.url === APIUrls.CSRF_TOKEN_URL) {
                delete req.headers['CSRF-Token'];
           } else if (!req.headers['CSRF-Token']){
                req.headers['CSRF-Token'] = localStorage.getItem("csrfToken");
           }
           return req;
        },
        (err) => {
           return Promise.reject(err);
        }
     );

     AuthAxiosInst.interceptors.response.use(
        (res) => {
            if(res?.data?.code === 401 || res?.data?.code === 403){
                logoutFunc();
                cookies.remove("userEmail",{ path: '/' });
                cookies.remove("i18nextLng",{ path: '/' });
                window.location.href ="/login"
            }
           return res;
        },
        (err) => {
            if (err.code === 'ERR_NETWORK') {
                console.error("Not able to connect to Bff server. Reason: ", err.message)
            }
            if (err.response?.data?.includes('invalid csrf token')) {
                console.error("CSRF Token is not available. Reason: ", err.message)
            }
           return Promise.reject(err);
        }
     );

     export const logError = (errorMessage, error) => {
        try{
            console.error(errorMessage, error);
            if(errorMessage !=null && errorMessage !== ''){
                postAxiosResponse(APIUrls.LOG_ERROR_URL, { errorStack : errorMessage});
            }
        }catch(err){
            console.error('error occurred while logging error.')
        }
      };
      
      export const handleError = (error) => {
        logError(error.stack, error);
      };

   

